import FeedPage from '~/pageComponents/FeedPage';
import getPageMetaTagsProps from '~/pageProps/metatags';

export default FeedPage;

export const getServerSideProps = getPageMetaTagsProps({
  title: 'HIC.AF Sponsors',
  description: 'Everyone who contributed to make HIC.AF what it is <3',
});
